package one.healthium.today.ui.period_tracker

import one.healthium.today.ui.models.PeriodTrackerUiModel

data class PeriodTrackerUiState (
    val uiModel: PeriodTrackerUiModel,
)
